import * as Yup from 'yup';

export const formConstants = {
  useTeamPermissions: {
    name: 'useTeamPermissions',
    label: 'Use Team Permissions',
    description:
      'If enabled, users will be able to be assigned to teams and will only have access to resources for the teams that they are assigned to.',
  },
  defaultTeamType: {
    name: 'defaultTeamType',
    label: 'Default Team Type',
  },
};

export const formValidation = Yup.object().shape({
  [formConstants.useTeamPermissions.name]: Yup.boolean(),
  [formConstants.defaultTeamType.name]: Yup.string(),
});
